import {injectGlobal} from '@emotion/css';
import {fonts, colours} from './variables';

export const typography = () => injectGlobal`

.label {
  font-weight: ${fonts.weight.SEMI_BOLD};
  font-size: ${fonts.size.L};
  &--emphasis {
    color: ${colours.semantic.INFORMATION};
  }
}

.noBreakText {
  white-space: nowrap;
}

.underline {
  text-decoration: underline;
}

.uppercase {
  text-transform: uppercase;
}

.link {
  color: ${colours.font.ASSISTIVE};
  text-decoration: none;
  &:focus {
    color: ${colours.brand.SECONDARY};
  }

  &:hover {
    color: ${colours.font.BLACK};
  }

  &--active,
  &.disabled,
  [disabled] {
    color: ${colours.brand.SECONDARY};
    pointer-events: none;
  }
}

a:not(.button):not(.unstyledLink) {
  color: ${colours.brand.SECONDARY};
  text-decoration: underline;

  &.hover,
  &:hover {
    color: ${colours.brand.SECONDARY};
    text-decoration: underline;
  }

  &.visited,
  &:visited,
  &.active,
  &:active {
    color: ${colours.semantic.INFORMATION_HOVER};
    text-decoration: underline;
  }
}

h1 {
  font-size: ${fonts.size.XXXXL}
}
h2 {
  font-size: ${fonts.size.XXXL}
}
h3 {
  font-size: ${fonts.size.XXL}
}
h4 {
  font-size: ${fonts.size.L}
}
h5 {
  font-size: ${fonts.size.S}
}
h6 {
  font-size: ${fonts.size.XS}
}

`;
